<template>
  <el-dialog :title="title" :visible.sync="domVisible" :custom-class="dialogClass" :close-on-click-modal="false" :lock-scroll="false" :before-close="closeDialog">
    <div v-loading.fullscreen="loading">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm">
        <el-form-item class="login_form_item" prop="userName">
          <div class="login_title">收货人</div>
          <el-input class="login_ipt" v-model="ruleForm.userName" placeholder="请输入收货人姓名" @input="setInput()"></el-input>
        </el-form-item>
        <el-form-item class="login_form_item" prop="mobile">
          <div class="login_title">手机号</div>
          <el-input class="login_ipt" v-model="ruleForm.mobile" placeholder="请输入收货人手机号" @input="setInput()"></el-input>
        </el-form-item>
        <el-form-item class="login_form_item" prop="provice">
          <div class="login_title">所在地区</div>
          <el-cascader class="login_ipt" popper-class="provinceList" separator=" " placeholder="请选择所在地区" v-model="ruleForm.provice" :options="provinceList" @change="proviceChange"></el-cascader>
        </el-form-item>
        <el-form-item class="login_form_item" prop="address">
          <div class="login_title">详细地址</div>
          <el-input class="login_ipt" v-model="ruleForm.address" placeholder="请输入收货人详细地址" @input="setInput()"></el-input>
        </el-form-item>
        <div class="tips">
          <div>设置为默认地址</div>
          <el-switch v-model="ruleForm.delivery"></el-switch>
        </div>
        <div class="tips" v-if="isSet"></div>
        <div class="login_btn_between">
          <el-button class="login_btn" @click="resetForm('ruleForm')">取消</el-button>
          <el-button class="login_btn" :disabled='disabled' type="primary" @click="submitForm('ruleForm')">确定</el-button>
        </div>
      </el-form>
    </div>
  </el-dialog>
</template>
<script>
import { getarea } from "@/api/area";
import { getInfo } from "@/api/public";
export default {
  name: 'getaddress',
  components: {},
  data() {
    return {
      userInfo:getInfo(),
      loading: false,
      provinceList:'',
      dislogType: this.$enumInfo.dislogType,
      flagType: 'password',
      flag: false,
      checked: true,
      disabled: true,
      dialogClass: 'address',
      proviceText: '',
      ruleForm: {
        userName: '',
        mobile: '',
        provice: [],
        address: '',
        delivery: false,
      },
      rules: {
        userName: [
          { required: true, message: '请输入收货人姓名', trigger: 'blur' },
        ],
        mobile: [
          { required: true, message: '请输入收货人手机号', trigger: 'blur' },
          { pattern: /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/, message: '请输入收货人手机号', trigger: 'blur' },
        ],
        provice: [
          { required: true, message: '请选择所在地区', trigger: 'change' },
        ],
        address: [
          { required: true, message: '请输入收货人详细地址', trigger: 'blur' },
        ]
      },
    }
  },
  props: {
    list:{},
    isSet: Boolean,
    title: String,
    domVisible: Boolean,
  },
  created() {
    this.getChinaAreas()
  },
  mounted() {
    let that = this
    window.addEventListener('keydown', function(e) {
      if (!that.disabled) {
        if (e.keyCode === 13) {
          that.submitForm('ruleForm')
        }
      }
    })
  },
  methods: {
    getChinaAreas(){
      let that=this
      that.$get(that.$interface.GetChinaAreas,'').then(res=>{
        if(res.Result==1){

          that.provinceList=getarea(res.Data)
          that.setDetail(that.list)
        }else{
              that.$message.error(res.Msg);
            }

      })
      
    },

    // 编辑时填写默认值
    setDetail(val){
      if(!this.isSet){
        let provice=val.Provice;
        provice=provice.split('-')
        this.ruleForm={
          userName: val.UserName,
          mobile: val.Mobile,
          provice: provice,
          address: val.AddressDetail,
          delivery: val.IsDefault,
        }
        this.disabled = false
      }
    },
    // 关闭
    closeDialog(val) {
      this.$emit('closeDialog', 'address', false)
    },
    // 判断input是否有值
    setInput() {
      if (this.ruleForm.userName != '' && this.ruleForm.mobile != '' && this.ruleForm.provice.length > 0 && this.ruleForm.address != '') {
        this.disabled = false
      } else {
        this.disabled = true
      }
    },
    // 所在区域 数组变成字符串 格式：xx-xx-xx
    proviceChange() {
      this.setInput();
      //console.log(this.ruleForm,'this.ruleForm')
      let data = this.ruleForm.provice ? this.ruleForm.provice : [];
      if(data.length>0){
        this.proviceText=data[0]+"-"+data[1]+"-"+data[2]
      }
    },
    // 提交表单
    submitForm(formName) {
      this.proviceChange();
      //return
      let that = this;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          that.disabled=true;
          that.loading=true;
          let data={
            memberId:that.userInfo._id,
            userName:that.ruleForm.userName,
            mobile:that.ruleForm.mobile,
            provice:that.proviceText,
            city:that.ruleForm.provice[1],
            addressDetail:that.ruleForm.address,
            country:'中国',
            isDefault:that.ruleForm.delivery,
          }
          let url=that.$interface.SaveAddress
          // 是否编辑地址
          if(!that.isSet){
            data=Object.assign({}, data, {id:that.list._id})
            url=that.$interface.UpdateAddress
          }
          that.$post(url,data).then(res=>{
            if(res.Result!=0){
              that.closeDialog()
            }else{
              this.$message.error(res.Msg);
            }
            that.disabled=false;
            that.loading=false;
          })
        }
      });
    },
    // 清空表单
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.closeDialog()
    }
  }
}

</script>
<style scoped>
@import "../../../static/css/address.css";

</style>



// WEBPACK FOOTER //
// src/components/dialog/address.vue